var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import { classNames } from '../../utils/cn';
var cls = classNames('menu-link');
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { useLink } from '../../hooks/use-link';
import { useMenu } from '../../hooks/use-menu';
import { Dot } from './dot';
export var MenuLinkDefaultProps = {}; // -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n    font-weight: 300;\n    font-size: 1em;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      color: ", ";\n    }\n\n    ", "\n  "], ["\n    color: ", ";\n    font-weight: 300;\n    font-size: 1em;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      color: ", ";\n    }\n\n    ", "\n  "])), theme.COLOR('dark'), theme.COLOR('primary'), function (_a) {
    var hasOutlineNumber = _a.hasOutlineNumber;
    return hasOutlineNumber && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-weight: 500;\n    "], ["\n      font-weight: 500;\n    "])));
  })
});
var DotStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n    display: flex;\n    border-radius: 50%;\n    margin-right: ", ";\n    margin-left: 2px;\n\n    ", "\n  "], ["\n    font-size: 12px;\n    width: 12px;\n    height: 12px;\n    display: flex;\n    border-radius: 50%;\n    margin-right: ", ";\n    margin-left: 2px;\n\n    ", "\n  "])), theme.UNIT(3), function (_a) {
    var _color = _a._color;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      background-color: ", ";\n      \n    "], ["\n      background-color: ", ";\n      \n    "])), _color);
  })
});
var OutlineNumberStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: ", ";\n    line-height: 1em;\n    margin-right: ", ";\n  "], ["\n    font-weight: 300;\n    font-size: ", ";\n    line-height: 1em;\n    margin-right: ", ";\n  "])), theme.FONT_SIZE(18), theme.UNIT(2))
}); // -------- Components -------->

var My = {
  Container: styled.span(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Dot: styled.span.attrs(cls.attr('dot'))(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), DotStyles),
  OutlineNumber: styled(Dot)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), OutlineNumberStyles)
};
export var MenuLink = function MenuLink(props) {
  var className = props.className,
      item = props.item;
  var linkStyle = {
    textDecoration: 'none'
  };
  var Link = useLink().Link;
  var menu = useMenu();
  var hasOutlineNumber = !!item.outlineNumber;
  var hasDot = !hasOutlineNumber && !!item.dot;
  return React.createElement(Link, {
    onClick: menu.hideOnClick,
    href: item.path,
    style: linkStyle
  }, React.createElement(My.Container, {
    hasOutlineNumber: hasOutlineNumber,
    className: cls.name(className)
  }, hasOutlineNumber && React.createElement(My.OutlineNumber, {
    size: 24,
    color: item.dot,
    className: cls.sub('outline-number')
  }, item.outlineNumber), hasDot && React.createElement(My.Dot, {
    _color: item.dot,
    className: cls.sub('dot')
  }), item.name));
};
MenuLink.defaultProps = MenuLinkDefaultProps;
MenuLink.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;